module.exports = __webpack_public_path__ + "static/img/rrrr_13.8286ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_13.png
// module id = 6lgs
// module chunks = 1